import api from './client';
import { Question } from '../types/testData';

export const createQuestion = async (testId: number, data: Partial<Question>): Promise<Question> => {
  const response = await api.post(`/questions?test_id=${testId}`, data);
  return response.data;
};

export const duplicateQuestion = async (id: number, count: number = 50): Promise<Question[]> => {
  const response = await api.post(`/questions/${id}/duplicate?count=${count}`);
  return response.data;
};

export const deleteQuestion = async (id: number): Promise<void> => {
  await api.delete(`/questions/${id}`);
};

export const updateQuestion = async (id: number, data: Partial<Question>): Promise<Question> => {
  const response = await api.put(`/questions/${id}`, data);
  return response.data;
};
